"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Map_1 = require("../Map");
var Static_1 = require("../Static");
var Field_1 = require("@xyo-network/coin-forms/build/lib/components/Field");
var quadkey_1 = require("../../utils/quadkey");
var navigator_1 = require("../../utils/navigator");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var ButtonBase_1 = __importDefault(require("@material-ui/core/ButtonBase"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogContentText_1 = __importDefault(require("@material-ui/core/DialogContentText"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var over_1 = __importDefault(require("lodash/over"));
exports.SelectQuadkey = react_1.forwardRef(function (_a, ref) {
    var mapProps = _a.mapProps, _b = _a.title, title = _b === void 0 ? 'Select Drop Location' : _b, _c = _a.description, description = _c === void 0 ? 'Drops will be restricted to users in the following location:' : _c, props = __rest(_a, ["mapProps", "title", "description"]);
    var _d = Field_1.useFormFieldContext(props.name || ''), state = _d.state, actions = _d.actions;
    var _e = react_1.useState(false), open = _e[0], setOpen = _e[1];
    var _f = react_1.useState(state.value || ''), value = _f[0], setValue = _f[1];
    var stopPropagation = function (ev) { return ev.stopPropagation(); };
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var handleMapMove = function (map, ev) {
        setValue(Map_1.getCurrentQuadkey(map));
    };
    var onSubmit = function () {
        handleClose();
        actions.setValue(value);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dialog_1.default, { open: open, fullWidth: true, maxWidth: "md", onClose: handleClose, "aria-labelledby": "form-dialog-title", scroll: "body" },
            react_1.default.createElement(DialogTitle_1.default, { id: "form-dialog-title" }, title),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(DialogContentText_1.default, null,
                    description,
                    react_1.default.createElement("span", { style: { display: 'block' } },
                        react_1.default.createElement("code", null, value))),
                react_1.default.createElement("div", { style: { position: 'relative' } },
                    open ? (react_1.default.createElement(Map_1.MapboxUser, __assign({ getInitialCenter: function () {
                            return state.value ? quadkey_1.origin(state.value) : navigator_1.getNavigatorLocation();
                        }, id: "geodrop-location" }, mapProps, { style: {
                            position: 'relative',
                            height: 400,
                            backgroundColor: 'rgba(0, 0, 0 ,0.2)',
                        }, handleMapLoad: handleMapMove, handleMapZoom: handleMapMove, handleMapDrag: handleMapMove }))) : (react_1.default.createElement("div", { style: {
                            position: 'relative',
                            height: 400,
                            backgroundColor: 'rgba(0, 0, 0 ,0.2)',
                        } })),
                    react_1.default.createElement("div", { className: "crosshair-h" }),
                    react_1.default.createElement("div", { className: "crosshair-v" }))),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { onClick: handleClose, color: "primary" }, "Cancel"),
                react_1.default.createElement(Button_1.default, { onClick: onSubmit, color: "primary" }, "Submit"))),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(TextField_1.default, __assign({ fullWidth: true }, props, { ref: ref, value: state.value || '', error: state.hasError, helperText: state.error || props.helperText, onClick: over_1.default([stopPropagation, handleOpen]) })),
            state.value && (react_1.default.createElement(ButtonBase_1.default, { onClick: over_1.default([stopPropagation, handleOpen]), style: {
                    marginTop: 16,
                    marginBottom: 8,
                    marginLeft: 8,
                    height: 56,
                    borderRadius: 4,
                } },
                react_1.default.createElement(Static_1.StaticQuadkeyMap, { accessToken: mapProps.accessToken, quadkey: state.value || '', style: {
                        minWidth: 56,
                        height: 56,
                        borderRadius: 4,
                    } }))))));
});
//# sourceMappingURL=index.js.map